// extracted by css-extract-rspack-plugin
export default {"gridContainer":"_2307113f"};